import useAuth from 'hooks/use-auth';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import APP_ROUTES from 'utils/routes';

export function protectRoute<Route extends object>(
  Component: React.ComponentType<Route>
) {
  return (props: Route) => {
    const { isAuthenticated, isAnonymous, loading } = useAuth();
    const router = useRouter();

    useEffect(() => {
      // Redirect all "unreal" users.
      if ((!isAuthenticated || isAnonymous) && !loading) {
        router.push(APP_ROUTES.users.signIn);
      }
    }, [loading, isAuthenticated, isAnonymous, router]);

    // Only allow "real" users to see the component.
    return isAuthenticated && !isAnonymous ? <Component {...props} /> : null;
  };
}
